import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-client',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, NgFor, NgIf, NgClass],
  templateUrl: './client.component.html',
  styleUrl: './client.component.scss'
})
export class ClientComponent {
  transparent = false;
  head: any[] = [];
  currentPage: string = 'client';
  imageBaseUrl = this.datasearch_service.ApiUrl + '/uploads/clients/';
  clients: any[] = [];
  showMore: boolean[] = [];
  shouldShowMore: boolean[] = []; // New array to conditionally show "Read More"
  currentUrl: string;

  constructor(private datasearch_service: DatasearchService) {
    this.currentUrl = window.location.href; // Get the current URL
  }

  ngOnInit() {
    this.getData();
    this.getHeading();
  }

  getData() {
    this.datasearch_service.getClients(1, 100).subscribe(
      (res) => {
        if (res && res.success && res.data) {
          // Filter only active clients
          this.clients = res.data.filter((client: any) => client.isActive === true);
          // Initialize the shouldShowMore array
          this.shouldShowMore = this.clients.map(client => this.isDescriptionLong(client.description));
        } else {
          this.clients = [];
          this.shouldShowMore = [];
        }
      },
      (error) => {
        console.error('Error fetching clients:', error);
        this.clients = [];
        this.shouldShowMore = [];
      }
    );
  }

  getHeading() {
    this.datasearch_service.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }

  toggleShowMore(index: number) {
    this.showMore[index] = !this.showMore[index];
  }

  // Function to determine if the description is long enough to show "Read More"
  isDescriptionLong(description: string): boolean {
    const textWithoutHTML = description.replace(/<[^>]+>/g, ''); // Remove HTML tags
    return textWithoutHTML.length > 500; // Adjust threshold as necessary
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }

}
